import './offersExample.scss'
import React from 'react'
import PropTypes from "prop-types";
import { i18n } from 'core/i18n';

import { getIsFullProfitability } from 'utilities/depositHelper'
import { formatInterest } from 'utilities/currencyHelper';


export const OfferExamples = ({ examples = [], originCountry }) => {
    const { FormattedText } = i18n;
    const isPassportCountry = !getIsFullProfitability(originCountry);
    const offerExamples = examples.map((example, index) => {
        const asterisks = Array(index + 1).fill('*').join('');
        const equalTinAndTae = example.tin === example.tae;
        const taeValue = formatInterest(example.tae, true, false);
        const tinValue = formatInterest(example.tin, true, false);
        const cancelCostValue = formatInterest(example.cancelCost, true, false);
        const exampleAmountValue = formatInterest(example.exampleAmount, false, false);
        const exampleInterestAmountCancelledValue = formatInterest(example.exampleInterestAmountCancelled, false, false);
        const exampleInterestAmountValue = formatInterest(example.exampleInterestAmount, false, false);
        
        const secondLine = <FormattedText value="deposits-deposits_OfferRepresentativeExampleSecondLine" injectedStrings={[example.months, exampleInterestAmountValue]} />;
        let thirdLine = <FormattedText value="deposits-deposits_OfferRepresentativeExampleThirdLine" injectedStrings={[example.cancelMonths, cancelCostValue, exampleInterestAmountCancelledValue]} />;
        let firstLine;
        if (isPassportCountry) {
            firstLine = <FormattedText value="deposits-deposits_OfferRepresentativeExampleFirstLinePassport" injectedStrings={[asterisks, exampleAmountValue, tinValue, example.months]} />;
            thirdLine = <FormattedText value="deposits-deposits_OfferRepresentativeExampleThirdLinePassport" injectedStrings={[example.cancelMonths, cancelCostValue, exampleInterestAmountCancelledValue]} />;
        } else if (equalTinAndTae) {
            firstLine = <FormattedText value="deposits-deposits_OfferRepresentativeExampleFirstLineEqualInterest" injectedStrings={[asterisks, exampleAmountValue, taeValue, example.months]} />;
        } else {
            firstLine = <FormattedText value="deposits-deposits_OfferRepresentativeExampleFirstLineDifferentInterest" injectedStrings={[asterisks, exampleAmountValue, taeValue, tinValue, example.months]} />;
        }

        return (
            <div key={index} className='deposit-offers-representative-examples__example'>
            <p>
                {firstLine}
            </p>
            <p>
                {secondLine}
            </p>
            <p>
                {thirdLine}
            </p>    
            </div>
        )
    })

    return (
        <div className='deposit-offers-representative-examples'>
            {offerExamples}
        </div>
    )
}

OfferExamples.propTypes = {
    examples: PropTypes.array.isRequired,
    originCountry: PropTypes.string.isRequired,
};
